import React from 'react';
import { ActionBar } from './styled';
import { CopyOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import copy from 'copy-to-clipboard';

const actions = [{ label: <CopyOutlined />, value: 'copy' }];

function Actions({ data }) {
  const handleActions = (value) => {
    if (value === 'copy') {
      return (event) => {
        // skip trigger cell actions like showing session details
        event.stopPropagation();
        if (copy(data)) {
          message.info('Copied to clipboard');
        }
      };
    }
    return () => null;
  };

  return (
    <ActionBar className="action-bar">
      {actions.map((action) => (
        <Button
          key={action.value}
          type="text"
          icon={action.label}
          style={{ color: '#0046ff' }}
          onClick={handleActions(action.value)}
        />
      ))}
    </ActionBar>
  );
}

export default Actions;
